import React, { useState, useEffect } from 'react';
import _isEmpty from 'lodash/isEmpty';
import _map from 'lodash/map';
import ConfirmDetails from 'styles/blocks/compound/confirmContactDetails';
import { CompoundBody } from './compoundBody';
import { NextButton } from '../nextButton';

const calculateAnswerStyles = () => `
  width: auto;
  margin: 0;
`;

const containerStyles = `
  flex-direction: column;
`;

export function CompoundConfirmContactDetails({ question, onClickNextQuestion, validationErrors, compoundAnswers, handleUpdateCompoundAnswer, isReadOnly }) {
  const [isEditingDetails, setIsEditingDetails] = useState(!_isEmpty(validationErrors));
  useEffect(() => {
    if (!_isEmpty(validationErrors)) {
      setIsEditingDetails(true);
    }
  }, [validationErrors]);

  return (
    <ConfirmDetails>
      <ConfirmDetails.Text>One last thing: double-check that your phone number and email are correct.</ConfirmDetails.Text>
      <ConfirmDetails.Text>Edit them if you need to.</ConfirmDetails.Text>
      {isEditingDetails ? (
        <ConfirmDetails>
          <CompoundBody
            question={question}
            validationErrors={validationErrors}
            compoundAnswers={compoundAnswers}
            handleUpdateCompoundAnswer={handleUpdateCompoundAnswer}
            calculateAnswerStyles={calculateAnswerStyles}
            containerStyles={containerStyles}
            isReadOnly={isReadOnly}
          />
          <div>
            <ConfirmDetails.UpdateButton onClick={() => setIsEditingDetails(false)}>Update details</ConfirmDetails.UpdateButton>
          </div>
        </ConfirmDetails>
      ) : (
        <div>
          {_map(question.questions, (subQuestion, i) => {
            return (
              <ConfirmDetails.DetailField key={`confirmContactDetailsField-${i}`}>
                <ConfirmDetails.Label>{subQuestion.text}</ConfirmDetails.Label>
                <ConfirmDetails.Bold>{compoundAnswers[subQuestion.answers[0].answerId].value}</ConfirmDetails.Bold>
              </ConfirmDetails.DetailField>
            );
          })}
          <ConfirmDetails.EditButton onClick={() => setIsEditingDetails(true)}>Edit details</ConfirmDetails.EditButton>
        </div>
      )}
      <NextButton dataAutomation={`nextButton-${question.questionId}`} onClick={onClickNextQuestion} isDisabled={isEditingDetails}>Confirm my details and finish</NextButton>
    </ConfirmDetails>
  );
}
